import { sendRequest } from './index';
import { API_ACTIVITIES_URL } from '@core/constants/API';

export const UtmActivity = (payload) => {
    return sendRequest({
        url: `${API_ACTIVITIES_URL}utm`,
        method: 'POST',
        body: payload
    });
};